import {
  MessageTypes,
  postMessageWhenControlled
} from "context/ServiceWorkerContext"

type StartupWorker = Parameters<typeof postMessageWhenControlled>[0]

export const sendStartupServiceWorkerMessages = (worker: StartupWorker) => {
  postMessageWhenControlled(worker, {
    type: MessageTypes.FlushStaleTickets
  })
  postMessageWhenControlled(worker, {
    type: MessageTypes.RegisterSentryClient
  })
}
